import React, { useState } from 'react';
import TableWithProductOnDate from './TableWithProductOnDate';

export default (props) =>{
  const [tableIndex, changeTableIndex] = useState(0);
  return <TableWithProductOnDate {...props} tableIndex={tableIndex} changeTableIndex={changeTableIndex}/>;
};

